import { every } from 'lodash'

import { useAppSelector } from 'app/store'
import { HUB_PROGRAMS } from 'app/constants/entitlement.constant'

const useIsHybridUser = (programs: HUB_PROGRAMS[]) => {
  const { hubPrograms, grade } = useAppSelector((state) => state.userData)

  return every(programs, (program) => hubPrograms[program].includes(grade))
}

export const useIsCKLAHybridUser = (program2: HUB_PROGRAMS) =>
  useIsHybridUser([HUB_PROGRAMS.CKLA, program2])

export const useIsCaminosHybridUser = (program2: HUB_PROGRAMS) =>
  useIsHybridUser([HUB_PROGRAMS.CAMINOS, program2])
